videojs.hook('setup', function(player){
	var video = player.el(), ec = '';
	var videoID = "";
	if(video.getAttribute('data-ga-ec')){
		ec = 'ec:' + video.getAttribute('data-ga-ec');
		videoID = video.getAttribute('data-ga-ec');
	} else {
		var videos = document.querySelectorAll('.video-js'), count = 0;
		for(var i = 0; i < videos.length; i++) {
			if(!videos[i].getAttribute('data-ga-ec')){
				count += 1;
				if(videos[i] == video){
					ec = 'ec:video' + (count < 10 ? '0' : '') + count;
					videoID = 'video' + (count < 10 ? '0' : '') + count;
				}
			}
		}
	}
	if(ec != ''){
		var exec_ga = function(el){
			ga(ec,"ea:play",el);
			console.log('ga ' + ec + ' ea:play ' + el);
		};
		player.on("play", function(){
			exec_ga("el:start");
			sendD2Param("movie_start", videoID);
		});
		player.on("25percent_play", function(e){
			exec_ga("el:25percent_play");
			sendD2Param("25", videoID);
		});
		player.on("50percent_play", function(e){
			exec_ga("el:50percent_play");
			sendD2Param("50", videoID);
		});
		player.on("75percent_play", function(e){
			exec_ga("el:75percent_play");
			sendD2Param("75", videoID);
		});
		player.on("100percent_play", function(e){
			exec_ga("el:100percent_play");
			sendD2Param("100", videoID);
		});
	}
	function sendD2Param(num, videoID){
		var currentPage = "story" + $("body").attr("data-num") + "_" + videoID;
		console.log("movied2  ", "c4:", currentPage, "c5:" ,num)
		__pParams.push({
			client_id: '162', c_1: 'cledepeau-beaute', c_2: 'WWD', c_3: 'movie', c_4: currentPage, c_5: num
		});
		$.getScript('//cdn.d2-apps.net/js/tr.js');
	}
});
